import React, { useEffect, useState } from 'react';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Container, Grid, Card } from '@mui/material';
import Footer from 'src/components/Footer';
import ReferralPayoutHeader from './ReferralPayoutHeader';
import { ReferralPayoutContent } from './ReferralPayoutContent';
import { useReferralPayout } from 'src/hooks/useReferralPayout';
import { ReferralPayoutResponse } from '../Referral/referral.interface';

const PAGE_SIZE = 30;

const ReferralPayout = () => {
  const { getReferralPayouts, loading: apiLoading } = useReferralPayout();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const [payouts, setPayouts] = useState<ReferralPayoutResponse[] | undefined>(undefined);
  const [totalPayouts, setTotalPayouts] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const fetchPayouts = async () => {
    setLoading(true);
    try {
      const data = await getReferralPayouts({ page, size: rowsPerPage, sort: 'createdAt,desc' });
      if (data) {
        setPayouts(data.content);
        setTotalPayouts(data.totalElements);
      }
    } catch (error) {
      console.error('Error fetching referral payouts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayouts().then();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (refresh) {
      fetchPayouts().then();
    }
  }, [refresh]);

  return (
    <>
      <title>Referral Payouts</title>
      <PageTitleWrapper>
        <ReferralPayoutHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
          <Grid item xs={12}>
            <Card>
              <ReferralPayoutContent
                payouts={payouts}
                onRefresh={() => setRefresh(!refresh)}
                loading={loading || apiLoading}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default ReferralPayout;
